/**
 * Flattens the summary data from an array to an object.
 *
 * Input Format
 * ```
 * [
 *   { category: 'my_category', count: 4 }
 * ]
 * ```
 *
 * Returned Format
 * ```
 * { my_category: 4 }
 * ```
 */
interface SummaryItem {
  category: string
  count: number
}

export default function flattenSummaryData(summary: SummaryItem[]) {
  return summary.reduce<Record<string, number>>((acc, row) => ({ ...acc, [row.category]: row.count }), {})
}
